import React, { useMemo } from 'react';

import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { subUnitGroupingAllowed } from '@modules/advancement/constants';
import type { GroupByToApproveTableOptions } from '@modules/advancement/purchaseOrder/duck/types';
import {
  Col,
  FilterButton,
  Radio,
  Row,
  TableFilterCard,
} from '@modules/shared/components';
import { unitTypeIdSel } from '@shared/duck/selectors/general.selectors';

import styles from './GroupBy.less';

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

interface GroupBy {
  onChange: (value: GroupByToApproveTableOptions) => void;
  onSubmit: () => void;
  groupByStatus: GroupByToApproveTableOptions;
  awardTabs: boolean;
}

export const GroupBy: React.FC<GroupBy> = props => {
  const { onSubmit, onChange, groupByStatus, awardTabs } = props;
  const unitTypeId = useSelector(unitTypeIdSel);

  const allowGroupBySubUnit = useMemo(
    () => subUnitGroupingAllowed.includes(unitTypeId),
    [unitTypeId],
  );

  return (
    <TableFilterCard
      className={styles.filter}
      content={
        <RadioGroup
          defaultValue={null}
          className={styles.radioBtnGroup}
          onChange={ev => {
            onChange(ev.target.value as GroupByToApproveTableOptions);
          }}
          value={groupByStatus}
        >
          <Row type="flex" justify="center" align="middle" gutter={8}>
            {allowGroupBySubUnit && (
              <Col span={8} className={styles.filterCol}>
                <RadioButton value="subUnit" className={styles.radioBtn}>
                  <FormattedMessage id="unitAdvancement.groupBy.subUnit" />
                </RadioButton>
              </Col>
            )}

            {!awardTabs && (
              <Col span={8} className={styles.filterCol}>
                <RadioButton value="scouts" className={styles.radioBtn}>
                  <FormattedMessage id="unitAdvancement.groupBy.scouts" />
                </RadioButton>
              </Col>
            )}

            <Col span={8} className={styles.filterCol}>
              <RadioButton value={null} className={styles.radioBtn}>
                <FormattedMessage id="unitAdvancement.groupBy.none" />
              </RadioButton>
            </Col>
          </Row>
        </RadioGroup>
      }
      onSubmit={onSubmit}
    >
      <FilterButton className={styles.groupBy}>
        <FormattedMessage id="unitAdvancement.groupBy" />
      </FilterButton>
    </TableFilterCard>
  );
};
